// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateColombianExternalPayProviderBank(bankCode: string, externalpayprovidercode: string): ?UserInputValidationError {
  if (externalpayprovidercode === 'achpse') {
    return bankCode ? VALID : { id: 'empty' };
  }
  return VALID;
}
